import { data } from '../../svg/Signature/data';
import { makeIcon } from '../makeIcon';

export const Signature = makeIcon(data, 'signature', 'Signature');

export default Signature;
